import { useEffect, useRef, useState } from 'react';
import { captureException } from '../../internal/ravenUtils';
export function useAuthConfigFetch(fetchAuthConfig) {
  const [configFetchState, setConfigFetchState] = useState({
    status: 'pending'
  });
  const fetchAuthConfigRef = useRef(fetchAuthConfig);
  // eslint-disable-next-line react-hooks/refs
  fetchAuthConfigRef.current = fetchAuthConfig;
  useEffect(() => {
    let cancelled = false;
    fetchAuthConfigRef.current().then(authConfig => {
      if (!cancelled) {
        setConfigFetchState(() => ({
          status: 'succeeded',
          config: authConfig
        }));
      }
    }).catch(err => {
      captureException(new Error('Failed to fetch auth config', {
        cause: err
      }));
      if (!cancelled) {
        setConfigFetchState(() => ({
          status: 'failed',
          err
        }));
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return configFetchState;
}